module.exports = __webpack_public_path__ + "static/media/4.b38985e3.jpg";